export default __webpack_public_path__ + "static/media/placeholder-signature.27f60ad4.png";